import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Wrench, Droplet, Hammer, Thermometer, ShowerHead, WrenchIcon, Zap } from 'lucide-react';
import { SEO } from '../components/SEO';
import { Breadcrumb } from '../components/Breadcrumb';
import { BreadcrumbSchema } from '../components/SchemaOrg';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';

const Services = () => {
  const services = [
    {
      icon: <Phone className="w-12 h-12 text-blue-600" />,
      title: 'Dépannage d\'Urgence 24/7',
      description: 'Votre chauffe-eau est en panne en plein hiver ? Une fuite importante inonde votre appartement ? Nos plombiers d\'urgence interviennent en moins de 30 minutes à Paris 17e et dans Paris et proche banlieue. Disponibles jour et nuit, week-ends et jours fériés, nous arrivons équipés pour résoudre rapidement votre problème. Service d\'astreinte permanent avec des techniciens expérimentés qui connaissent parfaitement les urgences plomberie.',
      details: [
        'Fuite d\'eau importante - intervention immédiate',
        'Canalisation complètement bouchée',
        'Panne de chauffe-eau sans eau chaude',
        'Robinetterie défectueuse impossible à fermer',
        'Intervention garantie sous 30 minutes dans Paris 17 et alentours'
      ]
    },
    {
      icon: <WrenchIcon className="w-12 h-12 text-blue-600" />,
      title: 'Installation Sanitaire Complète',
      description: 'Vous rénovez votre salle de bain ou votre cuisine ? NHM Plomberie vous accompagne de A à Z dans votre projet d\'installation sanitaire. Nos plombiers installateurs posent vos équipements neufs dans les règles de l\'art : baignoires, douches italiennes, WC suspendus, vasques design, robinetterie haut de gamme. Nous travaillons avec les meilleures marques et respectons scrupuleusement les normes DTU en vigueur.',
      details: [
        'Rénovation complète salle de bains et cuisines',
        'Pose de douche italienne et paroi de douche',
        'Installation WC suspendus et lave-mains',
        'Robinetterie thermostatique et mitigeurs',
        'Garantie décennale sur tous travaux d\'installation'
      ]
    },
    {
      icon: <Droplet className="w-12 h-12 text-blue-600" />,
      title: 'Détection et Réparation de Fuites',
      description: 'Votre facture d\'eau a explosé sans raison apparente ? Vous constatez des traces d\'humidité au plafond ? Nos experts en détection de fuite utilisent des technologies de pointe (caméra thermique, gaz traceur, électro-acoustique) pour localiser précisément l\'origine de la fuite, même cachée dans un mur ou sous une dalle. Réparation rapide et efficace avec garantie, pour éviter les dégâts des eaux coûteux.',
      details: [
        'Détection de fuite non-destructive par caméra',
        'Réparation robinetterie et joints défectueux',
        'Remplacement de tronçons de tuyauterie',
        'Recherche de fuite avant/après compteur',
        'Rapport détaillé pour assurance si besoin'
      ]
    },
    {
      icon: <Wrench className="w-12 h-12 text-blue-600" />,
      title: 'Débouchage de Canalisations',
      description: 'Évier qui ne s\'écoule plus, douche qui stagne, WC bouchés ? Notre service de débouchage professionnel intervient rapidement avec du matériel haute pression. Nous utilisons des techniques adaptées selon l\'obstruction : furet électrique, hydrocurage, inspection vidéo pour diagnostiquer l\'état de vos canalisations. Travail propre et efficace avec garantie de résultat. Conseils préventifs pour éviter les récidives.',
      details: [
        'Débouchage évier, lavabo et baignoire',
        'WC bouchés - intervention rapide',
        'Hydrocurage canalisation haute pression',
        'Inspection vidéo des canalisations',
        'Traitement curatif et préventif anti-bouchons'
      ]
    },
    {
      icon: <Thermometer className="w-12 h-12 text-blue-600" />,
      title: 'Chauffe-eau et Ballon d\'Eau Chaude',
      description: 'Installation, entretien et dépannage de tous types de chauffe-eau : électrique, gaz, thermodynamique, solaire. Nos techniciens qualifiés interviennent sur toutes les marques (Ariston, Atlantic, De Dietrich, Thermor). Remplacement rapide en cas de panne définitive avec enlèvement de l\'ancien appareil. Nous vous conseillons sur le modèle adapté à vos besoins (capacité, économies d\'énergie) et assurons une installation conforme.',
      details: [
        'Installation chauffe-eau électrique et gaz',
        'Remplacement ballon d\'eau chaude défectueux',
        'Entretien et détartrage régulier',
        'Réparation groupe de sécurité et résistance',
        'Conseil en chauffe-eau économique (thermodynamique)'
      ]
    },
    {
      icon: <Zap className="w-12 h-12 text-blue-600" />,
      title: 'Tuyauterie et Raccordements',
      description: 'Rénovation complète ou partielle de votre réseau de tuyauterie. Nous remplaçons les anciennes canalisations en plomb par des installations modernes en cuivre, PER ou multicouche. Mise aux normes de votre installation pour votre sécurité et celle de votre famille. Travaux de raccordement pour extension, création de pièce d\'eau supplémentaire. Soudure cuivre, raccords à sertir, nous maîtrisons toutes les techniques.',
      details: [
        'Remplacement tuyauterie plomb et galvanisée',
        'Installation réseau PER, cuivre, multicouche',
        'Mise aux normes eau potable et évacuation',
        'Raccordement appareils électroménagers',
        'Rénovation circuit eau chaude/froide complet'
      ]
    },
    {
      icon: <ShowerHead className="w-12 h-12 text-blue-600" />,
      title: 'Rénovation Salle de Bain Clé en Main',
      description: 'Projet complet de rénovation de salle de bain du sol au plafond. Notre équipe coordonne tous les corps de métier (plomberie, électricité, carrelage, peinture) pour vous livrer une salle de bain neuve clé en main. Design moderne et fonctionnel, matériaux de qualité, respect des délais. Nous gérons votre projet de A à Z avec un interlocuteur unique. Showroom virtuel pour visualiser votre future salle de bain.',
      details: [
        'Conception 3D et plan d\'aménagement',
        'Dépose complète de l\'existant',
        'Installation plomberie, électricité, ventilation',
        'Pose carrelage mural et sol',
        'Garantie décennale et assurance tous risques'
      ]
    },
    {
      icon: <Hammer className="w-12 h-12 text-blue-600" />,
      title: 'Entretien Préventif et Maintenance',
      description: 'Anticipez les pannes avec nos contrats d\'entretien plomberie pour particuliers et professionnels. Visite annuelle de nos techniciens pour vérifier l\'état de vos installations, détartrer votre chauffe-eau, contrôler les robinets et joints. Tarifs préférentiels sur les interventions pour nos clients sous contrat. Service idéal pour les copropriétés, commerces et entreprises souhaitant maintenir leurs installations en parfait état.',
      details: [
        'Contrat entretien annuel personnalisé',
        'Détartrage chauffe-eau et chaudière',
        'Vérification robinetterie et joints',
        'Contrôle pression et groupe de sécurité',
        'Tarifs préférentiels interventions et pièces'
      ]
    }
  ];

  const breadcrumbItems = [
    { name: 'Services', url: '/services' }
  ];

  return (
    <>
      <SEO
        title="Services Plomberie Paris 17e - Dépannage Installation | NHM"
        description="Tous nos services de plomberie dans Paris 17 et alentours: urgence 24/7, installation sanitaire, fuite, débouchage, chauffe-eau. Devis gratuit ☎ 09 70 70 58 63"
        keywords="services plomberie Paris 17, dépannage plombier Paris 17e, installation sanitaire, réparation fuite, débouchage canalisation, chauffe-eau, rénovation salle de bain"
        canonical="https://nhm-plomberie.fr/services"
      />
      <BreadcrumbSchema items={[{ name: 'Accueil', url: 'https://nhm-plomberie.fr/' }, ...breadcrumbItems.map(item => ({ name: item.name, url: `https://nhm-plomberie.fr${item.url}` }))]} />

      <Breadcrumb items={breadcrumbItems} />

      <section className="bg-blue-900 text-white py-16">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">Nos Services de Plomberie Professionnels</h1>
          <p className="text-xl text-blue-100 max-w-3xl">
            NHM Plomberie vous propose une gamme complète de services pour tous vos besoins en plomberie à Paris 17e et dans les Paris et sa proche banlieue. 
            De l'urgence au projet de rénovation, nos plombiers qualifiés interviennent avec professionnalisme et réactivité.
          </p>
        </div>
      </section>

      <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto prose prose-lg">
            <h2 className="text-3xl font-bold mb-6 text-gray-900">Expertise Plomberie Tous Corps d'État</h2>
            <p className="text-gray-700 leading-relaxed">
              Depuis notre création, <strong>NHM Plomberie</strong> s'est spécialisée dans l'ensemble des métiers de la plomberie et du chauffage. 
              Que vous soyez un <strong>particulier</strong> confronté à une urgence, un <strong>syndic de copropriété</strong> recherchant un prestataire fiable, 
              ou une <strong>entreprise</strong> nécessitant une maintenance régulière, nous adaptons nos services à vos besoins spécifiques.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Notre force réside dans la polyvalence de nos <strong>plombiers certifiés</strong> qui maîtrisent aussi bien le dépannage d'urgence 
              que les travaux de rénovation d'envergure. Chaque intervention est réalisée dans le respect des <strong>normes DTU</strong> et des 
              <strong> règles de l'art</strong>, avec des matériaux de qualité professionnelle.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12 text-gray-900">Détail de Nos Prestations</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {services.map((service, index) => (
              <Card key={index} className="hover:shadow-xl transition-all duration-300 border-2 hover:border-blue-600">
                <CardHeader>
                  <div className="mb-4">{service.icon}</div>
                  <CardTitle className="text-2xl">{service.title}</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-gray-700 mb-6 leading-relaxed">{service.description}</p>
                  <h4 className="font-semibold text-gray-900 mb-3">Nos prestations incluent:</h4>
                  <ul className="space-y-2">
                    {service.details.map((detail, idx) => (
                      <li key={idx} className="flex items-start gap-2">
                        <span className="text-blue-600 mt-1 font-bold">✓</span>
                        <span className="text-gray-700">{detail}</span>
                      </li>
                    ))}
                  </ul>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold mb-8 text-gray-900 text-center">Nos Zones d'Intervention</h2>
            <p className="text-lg text-gray-700 mb-6 text-center">
              Tous nos services sont disponibles dans l'ensemble de notre <Link to="/zone-intervention" className="text-blue-600 hover:underline font-semibold">zone d'intervention</Link> : 
              Paris 17e, Paris 8e, 9e, 16e, 18e, Levallois-Perret, Clichy, Neuilly-sur-Seine et communes limitrophes.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 bg-blue-900 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">Besoin d'un Devis ou d'une Intervention ?</h2>
          <p className="text-xl mb-8 text-blue-100 max-w-2xl mx-auto">
            Contactez-nous dès maintenant. Nos experts vous conseillent et établissent un devis gratuit personnalisé.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Button asChild size="lg" className="bg-white text-blue-900 hover:bg-blue-50 text-lg px-8 py-6">
              <a href="tel:0970705863" className="flex items-center gap-2">
                <Phone className="w-5 h-5" />
                09 70 70 58 63
              </a>
            </Button>
            <Button asChild size="lg" variant="outline" className="border-2 border-white text-white hover:bg-white hover:text-blue-900 text-lg px-8 py-6">
              <Link to="/contact">Demander un Devis Gratuit</Link>
            </Button>
          </div>
        </div>
      </section>
    </>
  );
};

export default Services;